import {FC, useEffect, useMemo, useRef, useState} from 'react'
import {
  fetchData,
  formatNumber,
  getEncodedCookie,
  getEncryptedRoute,
  toasterrormsg,
} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import {Link, useLocation} from 'react-router-dom'
import Select from 'react-select'
import {Tr} from '../../../../_metronic/i18n/Tr'

const Invoicedatavendorwise: FC = () => {
  let t = Tr()

  const location = useLocation()
  const categoryId = (location.state as any)?.categoryId || ''
  const period = (location.state as any)?.period || ''
  const actionId = (location.state as any)?.actionId || ''

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('') as any
  const [periodUsed, setPeriodUsed] = useState('0') as any
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any

  const [statusList] = useState([
    {value: '0', label: 'pending'},
    {value: '1', label: 'Approved'},
    {value: '3', label: 'Cancelled'},
    {value: '4', label: 'Completed'},
  ]) as any

  const currentMonth = new Date().getMonth() + 1

  const [monthList] = useState([
    {value: '1', label: 'January'},
    {value: '2', label: 'February'},
    {value: '3', label: 'March'},
    {value: '4', label: 'April'},
    {value: '5', label: 'May'},
    {value: '6', label: 'June'},
    {value: '7', label: 'July'},
    {value: '8', label: 'August'},
    {value: '9', label: 'September'},
    {value: '10', label: 'October'},
    {value: '11', label: 'November'},
    {value: '12', label: 'December'},
  ]) as any

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({length: currentYear - 2020 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const [selectedMonth, setSelectedMonth] = useState(currentMonth) as any
  const [selectedYear, setSelectedYear] = useState(currentYear) as any

  const getMonthStartAndEndDates = (year: number, month: number) => {
    if (!year || !month) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    const startDate = new Date(year, month - 1, 1)
    const endDate = new Date(year, month, 0)

    // Format dates in 'YYYY-MM-DD' to avoid timezone-related issues
    const formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${startDate.getFullYear()}`
    const formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}-${String(
      endDate.getMonth() + 1
    ).padStart(2, '0')}-${endDate.getFullYear()}`

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }
  }

  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  const getMonthNumberFromPeriod = (period: string) => {
    if (!period) return selectedMonth // Default to selectedMonth if period is empty

    const monthAbbr = period.split(' ')[0] // Extract "Apr" from "Apr 1 - Apr 30"
    const monthItem = monthList.find((m: any) => m.label.startsWith(monthAbbr))

    setSelectedMonth(monthItem.value)
    return monthItem ? monthItem.value : selectedMonth
  }

  const clearFields = () => {
    let receivedPeriod = getMonthNumberFromPeriod(period)
    setSelectedMonth(receivedPeriod)
    setSelectedYear(currentYear)
    setSelectedStatus('')
    InvoiceDataVendorWiseListApiCall('1', currentYear, '', 1)
  }
  const InvoiceDataVendorWiseListApiCall = async (
    isClear: any,
    year = selectedYear,
    month = selectedMonth,
    useFunction?: any
  ) => {
    let selectedMonthFinal = useFunction == 1 ? getMonthNumberFromPeriod(period) : month

    const {startDate, endDate} = getMonthStartAndEndDates(year, selectedMonthFinal)

    let param: any = {}

    if (isClear === '1') {
      param.fromDate = startDate
      param.toDate = endDate
      param.limit = limit
      param.offset = offset
      param.categoryId = categoryId
      param.actionId = actionId
    } else {
      param.fromDate = startDate
      param.toDate = endDate
      if (selectedStatus?.value != null && selectedStatus.value != undefined) {
        param.status = selectedStatus.value
      }
      param.limit = limit
      param.offset = offset
      param.actionId = actionId
      param.categoryId = categoryId
    }

    var res = await fetchData('admin/invoicepropertywisedata', param)
    if (res.status == '200') {
      var data = res.data
      setPaymentDetailList(data.data)
      setOrgPaymentDetailList(data.data)
      setTotalRecords(data.totalRecord)
      setPeriodUsed('1')
    } else {
      setPeriodUsed('1')
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.bookingCode != null &&
            item.bookingCode != '' &&
            String(item.bookingCode).toLocaleLowerCase().includes(text)) ||
          (item.vendorFullName != null &&
            item.vendorFullName != '' &&
            String(item.vendorFullName).toLocaleLowerCase().includes(text)) ||
          (item.categoryName != null &&
            item.categoryName != '' &&
            String(item.categoryName).toLocaleLowerCase().includes(text)) ||
          (item.bookingUserName != null &&
            item.bookingUserName != '' &&
            String(item.bookingUserName).toLocaleLowerCase().includes(text)) ||
          (item.toDate != null &&
            item.toDate != '' &&
            String(item.toDate).toLocaleLowerCase().includes(text)) ||
          (item.originalAmount != null &&
            item.originalAmount != '' &&
            String(item.originalAmount).toLocaleLowerCase().includes(text)) ||
          (item.totalAmount != null &&
            item.totalAmount != '' &&
            String(item.totalAmount).toLocaleLowerCase().includes(text)) ||
          (item.insayrRevenue != null &&
            item.insayrRevenue != '' &&
            String(item.insayrRevenue).toLocaleLowerCase().includes(text)) ||
          (item.propertyname != null &&
            item.propertyname != '' &&
            String(item.propertyname).toLocaleLowerCase().includes(text)) ||
          (item.toDate != null &&
            item.toDate != '' &&
            String(item.toDate).toLocaleLowerCase().includes(text))
        )
      })

      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Payment Details')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  const getBookingRoute = () => {
    if (categoryId == '1') {
      const menuId = getEncodedCookie('accommodationBookingMenuId')
      return getEncryptedRoute('../viewhotelbookingdetails', {menuId: menuId})
    } else if (categoryId == '4') {
      const menuId = getEncodedCookie('spacerentalBookingMenuId')
      return getEncryptedRoute('../viewspacebookingdetails', {menuId: menuId})
    } else if (categoryId == '5') {
      const menuId = getEncodedCookie('tourBookingMenuId')
      return getEncryptedRoute('../viewtourbookingdetails', {menuId: menuId})
    } else if (categoryId == '7') {
      const menuId = getEncodedCookie('carBookingMenuId')
      return getEncryptedRoute('../viewcarbookingdetails', {menuId: menuId})
    }
    return '' // default fallback
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Booking Id'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
              <Link
                to={getBookingRoute()}
                state={{
                  bookingId: row.bookingId,
                }}
              >
                {row.bookingCode != '' ? '#' + row.bookingCode : ''}
              </Link>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.bookingCode),
        width: '222px',
      },
      {
        name:
          categoryId == '1'
            ? t('Accommodation Name')
            : categoryId == '4'
            ? t('Space Rental Name')
            : categoryId == '5'
            ? t('Agency Name')
            : categoryId == '7'
            ? t('Supplier Name')
            : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionName != '' ? row.actionName : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.vendorFullName),
        filter: true,
        width: '222px',
      },
      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId == '1'
                ? 'Accommodation'
                : row.categoryId == '4'
                ? 'Space Rental'
                : row.categoryId == '5'
                ? 'Tour Package'
                : row.categoryId == '7'
                ? 'Car Rental'
                : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name:
          categoryId == '4'
            ? t('Space Type')
            : categoryId == '5'
            ? t('Tour Type')
            : categoryId == '7'
            ? t('Car Type')
            : t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyname != '' ? row.propertyname : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.propertyname),
        filter: true,
        width: '222px',
      },
      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.bookingUserName != '' ? row.bookingUserName : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.bookingUserName),
        filter: true,
        width: '222px',
      },
      {
        name:
          categoryId == '5'
            ? t('Tour date')
            : categoryId == '4'
            ? t('Renting Date')
            : categoryId == '7'
            ? t('Drop Off Date')
            : t('Check Out Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId != '5'
                ? row.toDate != ''
                  ? formatDate2(row.toDate)
                  : '-'
                : row.fromDate != ''
                ? formatDate2(row.fromDate)
                : ''}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.toDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.toDate ? new Date(rowA.toDate) : null
          const dateB = rowB.toDate ? new Date(rowB.toDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
        width: '222px',
      },

      {
        name: t('Booking Status'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.bookingStatus == 0 ? (
              <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Pending')}
              </span>
            ) : row.bookingStatus == 1 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Approved')}
              </span>
            ) : row.bookingStatus == 2 ? (
              <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Rejected')}
              </span>
            ) : row.bookingStatus == 3 ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Cancelled')}
                </span>
                <div className='text-center mt-2'>
                  {' '}
                  <span className='fw-bold fs-6'>
                    (
                    {row.cancellationCharge != ''
                      ? row.cancellationCharge + "% "+ t('Charges')
                      : "0% " + 'Charges'}
                    )
                  </span>
                </div>
              </>
            ) : row.bookingStatus == 4 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Completed')}
              </span>
            ) : (
              '-'
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.bookingStatus),
      },
      {
        name: t('Original Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.originalAmount != '' ? formatNumber(parseFloat(row.originalAmount)) : '0 UZS'}
              {/* {row.percentagePaid == '' ? '-' : '12%'} */}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.originalAmount),
        filter: true,
        width: '170px',
      },

      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' ? formatNumber(parseFloat(row.totalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: t('Insayr Fee') + "(%)",
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.insayrFee != '' ? row.insayrFee + '%' : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrFee),
        filter: true,
      },
      {
        name: t('Insayr Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrRevenue != '' ? formatNumber(parseFloat(row.insayrRevenue)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '170px',
      },
      {
        name: t('Vendor Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' && row.insayrRevenue != ''
                ? formatNumber(parseFloat(row.totalAmount) - parseFloat(row.insayrRevenue))
                : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrRevenue),
        filter: true,
        width: '170px',
      },
    ],
    [t]
  )

  useEffect(() => {
    InvoiceDataVendorWiseListApiCall('0', currentYear, '', '1')
    sessionStorage.removeItem('vendor')
    document.title = 'Insayr | View Invoice Data Vendor Wise'
  }, [limit, offset])

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)

    // if (newPage > currentPage) {
    //   setOffset(offset + limit)
    // } else {

    //   setOffset(offset - limit)
    // }
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  return (
    <>
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Month')}
            </label>
            <Select
              name='selectVendorMonth'
              id='selectVendorMonth'
              placeholder={t('Select Month')}
              isSearchable={true}
              options={monthList}
              value={monthList.find((option: any) => option.value == selectedMonth) || null}
              onChange={(e: any) => {
                setSelectedMonth(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Year')}
            </label>
            <Select
              name='selectVendorYear'
              id='selectVendorYear'
              placeholder={t('Select Year')}
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => {
                setSelectedYear(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='SelectStatus' className='fs-4 form-label'>
              {t('Select Status')}
            </label>
            <Select
              name='SelectStatus'
              id='SelectStatus'
              placeholder={t('Select Status')}
              isSearchable={true}
              options={statusList}
              value={selectedStatus}
              onChange={(e: any) => setSelectedStatus(e)}
              styles={{
                container: (provided) => ({...provided, width: '100%'}),
                control: (provided) => ({...provided, minHeight: 43}),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => InvoiceDataVendorWiseListApiCall('0')}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>

      <ToastContainer />

      <>
        <DataTable
          columns={column}
          data={paymentDetailList}
          pagination
          paginationServer={true}
          subHeader={true}
          onChangePage={handlePageChange}
          paginationTotalRows={totalRecords}
          paginationPerPage={10}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export {Invoicedatavendorwise}
